// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__va6vM","selected":"Chip_selected__2ZEtH"};